import useDefaultCustomsItem from 'components/CustomsForm/useDefaultCustomsItem'
import Dialog from 'components/Dialog'
import arrayMutators from 'final-form-arrays'
import lodash from 'lodash'
import React, { useState } from 'react'
import { Form as FinalForm } from 'react-final-form'
import { toast } from 'react-toastify'
import styled from 'styled-components'

import { request } from '../../../../1stlog-ui/src/utils'
import Form from './Form'

const Wrapper = styled.div``

const CustomsItemEditor = (props) => {
  const { item, refresh, ...rest } = props

  const isDelete = lodash.get(item, 'isDelete')

  const [form, setForm] = useState({})
  const [isLoading, setIsLoading] = useState(false)

  const createDefaultItem = useDefaultCustomsItem()

  const onSubmit = ({ item: values }) => {
    if (isDelete) {
      remove(item)
      return
    }

    const payload = serializeValues(values)

    if (item) {
      update(payload)
    } else {
      create(payload)
    }
  }

  const create = async (values) => {
    try {
      setIsLoading(true)
      const { data } = await request({
        method: 'put',
        url: '/api/customs',
        data: values,
      })
      toast.success('Ware wurde hinzugefügt.')
      refresh()
      rest.close()
    } catch (err) {
      console.error('RequestLoader failed', err)
      toast.error('Ware konnte nicht hinzugefügt werden.')
    } finally {
      setIsLoading(false)
    }
  }

  const update = async (values) => {
    try {
      setIsLoading(true)
      const { data } = await request({
        method: 'patch',
        url: `/api/customs/${values.id}`,
        data: values,
      })
      toast.success('Ware wurde aktualisiert.')
      refresh()
      rest.close()
    } catch (err) {
      console.error('RequestLoader failed', err)
      toast.error('Ware konnte nicht aktualisiert werden.')
    } finally {
      setIsLoading(false)
    }
  }

  const remove = async (values) => {
    try {
      setIsLoading(true)
      const { data } = await request({
        method: 'delete',
        url: `/api/customs/${values.id}`,
        data: values,
      })
      toast.success('Ware wurde gelöscht.')
      refresh()
      rest.close()
    } catch (err) {
      console.error('RequestLoader failed', err)
      toast.error('Ware konnte nicht gelöscht werden.')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Dialog
      {...rest}
      width75={!isDelete}
      title={`Zollware ${
        isDelete ? 'löschen' : item ? 'bearbeiten' : 'erstellen'
      }`}
      closeButton="Schliessen"
      submitButton={isDelete ? 'Löschen' : item ? 'Aktualisieren' : 'Erstellen'}
      submitButtonClass={isDelete ? 'danger' : 'primary'}
      onSubmit={isDelete ? onSubmit : form.submit}
      isLoading={isLoading}
    >
      {isDelete ? (
        <div>
          <div>
            Möchten Sie diesen Eintrag wirklich aus der Datenbank entfernen?
          </div>
        </div>
      ) : (
        <FinalForm
          onSubmit={onSubmit}
          subscription={{ submitting: true, pristine: true }}
          mutators={{ ...arrayMutators }}
        >
          {(formProps) => {
            return (
              <Form
                {...formProps}
                setForm={setForm}
                initialValues={item ? parseValues(item) : createDefaultItem()}
              />
            )
          }}
        </FinalForm>
      )}
    </Dialog>
  )
}

export default CustomsItemEditor

export function serializeValues(values) {
  return {
    ...lodash.omit(values, ['value', 'isDelete']),
    value: lodash.get(values, 'value.value'),
    valueCurrency: lodash.get(values, 'value.currency'),
  }
}

export function parseValues(values) {
  return {
    ...lodash.omit(values, ['value', 'valueCurrency']),
    value: {
      value: lodash.get(values, 'value'),
      currency: lodash.get(values, 'valueCurrency'),
    },
    preferenceCode: String(values.preferenceCode),
  }
}
